/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OtherVitals from './other-vitals';
import OtherVitalsDetail from './other-vitals-detail';
import OtherVitalsUpdate from './other-vitals-update';
import OtherVitalsDeleteDialog from './other-vitals-delete-dialog';

const OtherVitalsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OtherVitals />} />
    <Route path="new" element={<OtherVitalsUpdate />} />
    <Route path=":id">
      <Route index element={<OtherVitalsDetail />} />
      <Route path="edit" element={<OtherVitalsUpdate />} />
      <Route path="delete" element={<OtherVitalsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OtherVitalsRoutes;
